import React, { useEffect, useState } from 'react';
import { FaTwitter, FaTiktok, FaInstagram, FaSignOutAlt, FaGamepad } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getUser } from '../../services/api';
import AdBanner from '../AdBanner/AdBanner';
import './Navbar.css';

// `gamePage`: pantallas de partida. Ahí el anuncio de arriba no va en celular, donde quedaría
// casi pegado a los botones del juego (ya hay uno debajo del tablero, ver AdBanner).
const Navbar = ({ gamePage = false }) => {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        if (user) {
            getUser()
                .then(data => setUserData(data))
                .catch(error => console.error('Error fetching user data:', error));
        }
    }, [user]);

    const handleLogoutClick = () => {
        logout();
        navigate('/');
    };

    const displayName = userData?.user?.username || user?.username || '';
    // eslint-disable-next-line no-unused-vars
    const photoUrl = userData?.user?.photoUrl || user?.photoUrl || '';

    return (
        <>
        <nav className="navbar">
            <div className="navbar-container">
                {/* Left: socials */}
                <div className="navbar-socials">
                    <a href="https://twitter.com/footytictactoe" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
                    <a href="https://www.tiktok.com/@footytictactoe" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
                </div>

                <div className="navbar-spacer" />

                {/* Right: auth */}
                <div className="navbar-auth">
                    {user ? (
                        <>
                            <div className="navbar-user">
                                <span className="navbar-username">{displayName}</span>
                            </div>
                            <button className="navbar-logout" onClick={handleLogoutClick} title="Cerrar sesión">
                                <FaSignOutAlt />
                            </button>
                        </>
                    ) : (
                        <button className="navbar-login-btn" onClick={() => navigate('/login')}>
                            <svg className="navbar-google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                            </svg>
                            Iniciar sesión
                        </button>
                    )}
                    <a href="https://www.instagram.com/footytictactoe/" target="_blank" rel="noopener noreferrer" className="navbar-social-right"><FaInstagram /></a>
                    <a href="https://www.footy-games.com.ar" className="navbar-game-icon" target="_blank" rel="noopener noreferrer">
                        <FaGamepad />
                    </a>
                </div>
            </div>
        </nav>
        {/* Bloque de AdSense, común a todas las páginas que usan el Navbar. */}
        <AdBanner placement={gamePage ? 'top-game' : 'top'} />
        </>
    );
};

export default Navbar;
